import history from 'components/Layout/history';

let previousLocation = null;
let currentLocation = history.location;

const isLocationChanged = location =>
  currentLocation.pathname !== location.pathname || currentLocation.search !== location.search;

history.listen(location => {
  if (isLocationChanged(location)) {
    previousLocation = currentLocation;
    currentLocation = location;
  }
});

export const getPreviousLocation = () => previousLocation;

export const getReferrerLocation = () =>
  document.referrer ? { pathname: new URL(document.referrer).pathname } : null;
